export enum ReportTypeEnum {
  employee = 'employee',
  material = 'material',
}
